import React from 'react';
import Card from '../ui/Card';

interface ImportProjectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ImportProjectModal: React.FC<ImportProjectModalProps> = ({ isOpen, onClose, onImport }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <Card className="w-full max-w-md">
                <h2 className="text-xl font-bold mb-4">Import Project</h2>
                <input
                    type="file"
                    accept=".json"
                    onChange={onImport}
                    className="w-full mb-4"
                />
                <div className="flex justify-end gap-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 border border-border rounded hover:bg-muted"
                    >
                        Cancel
                    </button>
                </div>
            </Card>
        </div>
    );
};
